import { useTranslation } from 'react-i18next';
import { Box, Grid, Paper } from '@mui/material';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import PageTabNavigation, { PageTabItem } from 'src/shared/components/navigations/pageTabNavigation';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import SendingGrid from 'src/modules/sending/components/sendingGrid';
import GridActionButtons from 'src/modules/sending/components/gridActionButtons';

export const SendingOrderOverviewPage = () => {
  const { t } = useTranslation();

  const pageTabs: PageTabItem[] = [
    { label: 'Pågående', route: RoutesEnum.Sending, rawLabel: true },
    { label: 'Avslutade', route: RoutesEnum.SendingCompleted, rawLabel: true },
  ];

  return (
    <GridWrapper>
      <Grid item xs={12} md={4} sx={{ display: 'flex' }}>
        <MainContentHeader title={t('Beställningar')} />
      </Grid>
      <Grid item xs={12} md={8} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <GridActionButtons />
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <PageTabNavigation pageTabs={pageTabs} />
          <Box className='section-inset'>
            <SendingGrid />
          </Box>
        </Paper>
      </Grid>
    </GridWrapper>
  );
};
